import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react'
import EditorialComponentsFactory from './editorial-components-factory'

export default function RenderComponents({
    pageComponents,
    //blogsPage,
    contentTypeUid,
    entryUid,
    locale,
}) {
    //console.debug('pageComponents:', pageComponents)
    //console.debug('blogsPage:', blogsPage)

    return (
        <Box data-pageref={entryUid} data-contenttype={contentTypeUid} data-locale={locale}>
            {Array.isArray(pageComponents) &&
                pageComponents.length > 0 &&
                pageComponents.map((component, index) => {
                    const componentType = component?._content_type_uid
                    return (
                        <Fragment key={index}>
                            <EditorialComponentsFactory
                                componentType={componentType}
                                {...component}
                            />
                        </Fragment>
                    )
                })}
        </Box>
    )
}

RenderComponents.propTypes = {
    pageComponents: PropTypes.arrayOf(
        PropTypes.shape({
            hero_banner: PropTypes.object,
            section: PropTypes.object,
            section_with_buckets: PropTypes.shape({
                bucket_tabular: PropTypes.bool,
            }),
            from_blog: PropTypes.array,
            section_with_cards: PropTypes.shape({
                cards: PropTypes.array,
            }),
            section_with_html_code: PropTypes.object,
            our_team: PropTypes.object,
        }),
    ),
    blogsPage: PropTypes.bool,
    contentTypeUid: PropTypes.string.isRequired,
    entryUid: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
}
